import React, { SyntheticEvent } from 'react';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import DeleteButton from '@components/DeleteButton';
import Input from '@components/Form/Input';
import TxtCodeUploadButton from './TxtCodeUploadButton';
import CouponUtils from "@root/utils/CouponUtils";

interface Props {
    name: string;
    codes: CodeCodeUsageCount[] | null;
    maxUsageCount: number;
    generatedCodesCount: number | null;
    onChange: (value: CodeCodeUsageCount[] | null, name: string) => void;
}

export interface CodeCodeUsageCount {
    code: string;
    usage_count: number | null;
}

class CouponCodesField extends React.Component<Props & InjectedIntlProps> {

    private add = (e: SyntheticEvent) => {
        e.preventDefault();
        const codes = [...(this.props.codes || []), { code: "", usage_count: null }];
        this.props.onChange(codes, this.props.name);
    }

    private remove = (index: number) => {
        const codes = [...(this.props.codes || [])];
        codes.splice(index, 1);
        this.props.onChange(codes, this.props.name);
    }

    private onChange = (index: number) => (val: string, name: string) => {
        const codes = [...(this.props.codes || [])];
        codes[index].code = val;
        this.props.onChange(codes, this.props.name);
    }

    private renderValue = () => {
        if (!this.props.codes) {
            return null;
        }
        return (
            <table className="table table-borderless couponsTable">
                <thead>
                    <tr>
                        <th className="col-sm-10">Kuponkód</th>
                        <th className="col-sm-1">Felhasználható</th>
                        <th className="col-sm-1" />
                    </tr>
                </thead>
                <tbody>
                    {this.props.codes.map((code, index) => {
                        return (
                            <tr key={index}>
                                <td className="col-sm-10"><Input type="text" name="from" value={code.code} onChange={this.onChange(index)} placeholder="Kód" /></td>
                                {code.usage_count || code.usage_count === 0 ? <td className="col-sm-1"><span>{code.usage_count}</span></td> : <td />}
                                <td className="col-sm-1"><DeleteButton className="btn-block" onClick={this.remove} value={index} /></td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    private onUpload = (codes: string[]) => {
        const codesToUpload: CodeCodeUsageCount[] = codes ? codes.map((code: string) => {
            return {
                code,
                usage_count: this.props.maxUsageCount,
            };
        }) : [];
        this.props.onChange(codesToUpload, this.props.name);
    }

    public render() {
        return (
            <>
                {this.renderValue()}
                <div className="row">
                    <div className="col-sm-4">
                        <button className="btn btn-primary btn-block" onClick={this.add}>{this.props.intl.formatMessage({ id: 'common.add' })}</button>
                    </div>
                    <div className="col-sm-4">
                        <TxtCodeUploadButton onUpload={this.onUpload} />
                    </div>
                    <div className="col-sm-4">
                        <DeleteButton className="btn-block" onClick={() => { this.props.onChange([], this.props.name); }}>Összes törlése</DeleteButton>
                    </div>
                </div>
                {this.props.generatedCodesCount &&
                    (<div className="row couponsExtraInfo">
                        <p>Generált kuponkódok száma: {this.props.generatedCodesCount} db</p>
                        <p>Felhasznált kuponkódok száma: {CouponUtils.getUsedCodesCount(this.props.codes, this.props.maxUsageCount) || 0} db</p>
                    </div>)
                }
            </>
        );
    }
}

export default compose(
    injectIntl,
)(CouponCodesField);



// WEBPACK FOOTER //
// ./src/modules/Coupon/components/CouponCodesField.tsx